import { Divider } from "@mui/material"
import { isEmpty } from "lodash"
import PositionRow from "./position-row"

interface TagAttributeTooltipProps {
  label: string
  currency: string | undefined
  items?: string[]
  values: number[]
}

export default function TagAttributeTooltip({
  label,
  currency,
  items,
  values,
}: TagAttributeTooltipProps) {
  if (!items) {
    return null
  }
  return (
    <div className="tag-attribute-tooltip">
      <div>
        <div className="tooltip-row">
          <span>{label}</span>
          {!isEmpty(values) && <span>Size</span>}
        </div>

        <Divider />

        {items.map((item, index) => (
          <PositionRow
            key={item}
            label={item}
            currency={currency}
            economicExposure={values[index]}
          />
        ))}
      </div>
    </div>
  )
}
